<script>
  import ActionReportMixin from './ActionReportMixin.vue'

  export default {
    name: 'RbvHotelRfpBidManagerSetNoThankYouPendingActionReport',
    mixins: [ ActionReportMixin ],
    data () {
      return {
        messages: {
          'OK': 'Pending "No Thank You" Set',
          'NOT_FOUND': `Bid was not found`,
          'STATUS_CHANGED': 'Bid status was changed',
          'ERROR': '"No Thank You" Pending not set due to unknown error'
        }
      }
    },
    computed: {
      title () { return this.items.length === 1 ? 'Pending "No Thank You" not set!' : 'There were errors...' },
      message () {
        return this.items.length === 1
          ? 'We were not able to set "No Thank You" pending states because of the reason listed below:'
          : `${this.items.length - this.failures} of ${this.items.length} successfully set to "No Thank You" Pending state.<br /> We were not able to set others because of the reasons listed below:`
      }
    }
  }
</script>
